import Parse from "parse";

Parse.initialize("hgdemo");
//Parse.serverURL = "https://hgneu.openinc.de/parse";
Parse.serverURL = "https://schwarz.henrichgruppe.com/parse";
